import { gql } from '@apollo/client';

export const BOOKING_DATA = gql`
  query GetBookingDetails($bookingId: String!) {
    boatnew_booking(where: { id: { _eq: $bookingId } }) {
      tour_date
      product {
        id
        strapi {
          id
        }
        cities_products {
          city {
            name
            id
            strapi_city {
              id
            }
          }
        }
      }
      customer {
        contact_name
        email
      }
    }
  }
`;
